const isPluginFabric = (plugin) => typeof plugin === "function";
const usePlugin = (app, plugin, ...options) => {
  if (isPluginFabric(plugin)) {
    app.use(plugin(...options));
  } else {
    app.use(plugin);
  }
};
export {
  usePlugin as u
};
//# sourceMappingURL=use-plugin-11255fbd.mjs.map
